import { PageHeader, PageHeaderProps, Typography } from 'antd';
import { Helmet } from 'react-helmet-async';

import styles from './PageTitle.module.css';

type PageTitleProps = PageHeaderProps & {
  title: string;
  level?: 1 | 2 | 3 | 4 | 5;
  titleMarginLeft?: number;
};

const PageTitle = ({
  title,
  subTitle,
  level = 1,
  titleMarginLeft = 0,
  ...props
}: PageTitleProps) => {
  return (
    <>
      <Helmet>
        <title>{title} | Recrutamento e Seleção</title>
      </Helmet>
      <PageHeader
        className={styles.pageTitle}
        title={
          <Typography.Title
            style={{ marginLeft: titleMarginLeft }}
            level={level}
            className={styles.title}
          >
            {title}
          </Typography.Title>
        }
        subTitle={
          subTitle ? (
            <Typography.Title level={4} className={styles.subTitle}>
              {subTitle}
            </Typography.Title>
          ) : null
        }
        {...props}
      />
    </>
  );
};

export default PageTitle;
